module.exports = __webpack_public_path__ + "fonts/baronsans-thin-webfont.e402d778.woff";